/* eslint-disable */

import { Component } from '@verndale/core';
import $ from 'jquery';
import Flickity from 'flickity';
import jQueryBridget from 'jquery-bridget';
import 'flickity-as-nav-for/as-nav-for';
import 'flickity-fade';

class Module extends Component {
  setupDefaults() {
    this.dom = {};
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);
    this.initCarousel();
  }

  addListeners() {
    $('[lazy-load-style').each(function () {
      const $this = $(this);
      $this.attr('style', $this.attr('lazy-load-style'));
    });
  }

  isInViewport($el) {
    const elementTop = $el.offset().top;
    const elementBottom = elementTop + $el.outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  initCarousel() {
    const $eventPromotions = $('section.event-promotion-sb');
    const $this = this;
    if ($eventPromotions.length) {
      $eventPromotions.each(function () {
        const $promotion = $(this);
        const $slider = $promotion.find('.event-promotion-upcoming-carousel');
        const $sliderCards = $slider.find('.event-promotion-event-card');
        const slideCount = $slider.find('.event-promotion-event-card-buffer').length;
        let animated = false;

        if (!$promotion.find('.national-promotion').length) {
          $promotion.find('.event-promotion-featured').not('.ee').remove();
        }

        function buildSlider() {
          const useFlickity = slideCount > 2 || slideCount === 2 && $(window).outerWidth() < 1280;

          if ($slider.data('flickity')) {
            $slider.flickity('destroy');
          }

          if (useFlickity) {
            $sliderCards.removeAttr('data-aos').removeAttr('data-aos-duration');
            $slider.flickity({
              adaptiveHeight: false,
              imagesLoaded: true,
              setGallerySize: true,
              contain: true,
              cellAlign: 'left',
              wrapAround: true
            });
          }
        }

        function fadeIn() {
          // sort by position.left so always from left to right
          const unfadedCards = $sliderCards.filter('.pre-fade').toArray();

          if (unfadedCards.length) {
            $(unfadedCards[0]).removeClass('pre-fade');
          }

          if (unfadedCards.length && unfadedCards.length > 1) {
            setTimeout(fadeIn, 250);
          }
          else {
            animated = true;
          }
        }

        function animateSlider() {
          if ($this.isInViewport($slider)) {
            if (!animated) {
              setTimeout(fadeIn, 250);
            }
          }
          else {
            if (animated) {
              $sliderCards.addClass('pre-fade');
            }
            animated = false;
          }
        }

        $(window).resize(function () {
          buildSlider();
          animateSlider();
        });
        
        $(window).on('scroll', () => {
          animateSlider();
        });

        buildSlider();
        animateSlider();

        $promotion.addClass('ready');
      });
    }
  }
}

export default Module;
